import { render } from "./OpportunityMain.vue?vue&type=template&id=8a7c351a&scoped=true&lang=true"
import script from "./OpportunityMain.vue?vue&type=script&lang=js"
export * from "./OpportunityMain.vue?vue&type=script&lang=js"

import "./OpportunityMain.vue?vue&type=style&index=0&id=8a7c351a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8a7c351a"

export default script